import { Alert, Card as AntdCard, Col, Pagination, Row, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { Card } from '../../../../../components'
import { api } from '../../../../../services'
import TrainingListActions from '../components/TrainingListActions'
import TrainingListContainer from '../components/TrainingListContainer'
import { types } from '../types'
import { Container, Draggable } from 'react-smooth-dnd'
import TrainingSequence from '../components/TrainningSquence'
import { useTranslation } from 'react-i18next'

function SkillJourneyList(props) {
  const [skillJourneys, setSkillJourneys] = useState([])
  const [priorityLoad, setPriorityLoad] = useState(false)
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 12,
    total: null,
    offset: 0
  })
  const [error, setError] = useState(false)
  const [search, setSearch] = useState('')
  const [sequenceState, setSequenceState] = useState(false)
  const [seqList, setSeqList] = useState([])
  const [newSequence, setNewSequence] = useState([])
  useEffect(() => {
    const fetchMazeData = () => {
      if (!loading) setLoading(true)
      api.skillJourney
        .listSkillJourneys({
          offset: pagination.offset,
          limit: pagination.limit,
          mode: 'all',
          search
        })
        .then(res => {
          if (res.data) {
            setSkillJourneys(res.data.data)
            setPagination({ ...pagination, total: res.data.pagination.total })
            setLoading(false)
            setError(false)
          }
        })
        .catch(err => {
          setPagination({ ...pagination, total: null })
          setSkillJourneys([])
          setLoading(false)
          setError(true)
        })
    }
    fetchMazeData()
  }, [pagination.page, pagination.offset, search])
  useEffect(() => {
    if (sequenceState) {
      fetchPrioritiesCourses()
    }
  }, [sequenceState])
  const fetchPrioritiesCourses = () => {
    setPriorityLoad(true)
    api.skillJourney
      .getSkillList({
        mode: 'priorities',
        order: 'created_at',
        offset: pagination.offset,
        limit: 10
      })
      .then(({ data }) => {
        setSeqList(data)
        setPriorityLoad(false)
      })
      .catch(err => {
        setPriorityLoad(false)
      })
  }
  const handlePagination = pageNumber => {
    setPagination({
      ...pagination,
      page: pageNumber,
      offset: pageNumber * pagination.limit - pagination.limit
    })
  }
  const handleSearch = searchValue => {
    setPagination({ ...pagination, page: 1, offset: 0 })
    setSearch(searchValue)
  }
  const onCardClick = ({ id }) => props.history.push(`/skill-journey/${id}`)

  const showItems = !loading && skillJourneys.length > 0
  const handleSaveSequence = () => {
    setPriorityLoad(true)
    let data = []
    newSequence.forEach((item, i) => {
      data.push({ skill_id: item.id, priority: i })
    })
    api.skillJourney
      .setSequence({ skills: data })
      .then(res => {
        message.success(t('v5:order_sequence_set_successfully'))
        setPriorityLoad(false)
        setSequenceState(false)
      })
      .catch(err => {
        message.error(err.message)
        setPriorityLoad(false)
        setSequenceState(false)
      })
  }
  const { t } = useTranslation()
  return (
    <TrainingListContainer title={t('v4:skill_journey')}>
      <TrainingListActions
        type={types.SKILLJOURNEY}
        loading={loading}
        onListSearch={handleSearch}
        sequenceState={sequenceState}
        handleSaveSequence={handleSaveSequence}
        openSequenceState={val => {
          setSequenceState(val)
        }}
      />
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={sequenceState ? 16 : 24}>
          {showItems && (
            <div className="training-list-pagination">
              <h2>
                {search && (
                  <>
                    {t('v4:search_result')} <u>{search}</u> -
                  </>
                )}{' '}
                {skillJourneys.length}{' '}
                {skillJourneys.length <= 1 ? t('v2:item') : t('v3:items')}
              </h2>
            </div>
          )}
          {loading ? (
            <div className="training-list-cards">
              {Array.from(Array(pagination.limit).keys()).map(item => (
                <AntdCard style={{ width: 250 }} loading>
                  {t('v4:this_card')}
                </AntdCard>
              ))}
            </div>
          ) : error ? (
            <Alert type="error" message="Error !" />
          ) : skillJourneys.length === 0 ? (
            <Alert
              message={
                search
                  ? `${t('v4:search_for')} '${search}' ${t(
                      'v4:search_no_result'
                    )}`
                  : t('v4:no_skill_journey')
              }
            />
          ) : (
            <div className="training-list-cards">
              {skillJourneys.map((item, index) => (
                <Container
                  key={index}
                  groupName="1"
                  behaviour="copy"
                  getChildPayload={() => item}
                >
                  <Draggable payload={item}>
                    <Card
                      type={types.SKILLJOURNEY}
                      mode="skill"
                      data={item}
                      onClick={onCardClick}
                      tagName="skill"
                    />
                  </Draggable>
                </Container>
              ))}
            </div>
          )}
          <div className="pagination-wrapper">
            {!loading && skillJourneys.length > 0 && (
              <Pagination
                disabled={loading}
                total={pagination.total}
                pageSize={pagination.limit}
                onChange={handlePagination}
                current={pagination.page}
              />
            )}
          </div>{' '}
        </Col>
        {sequenceState && (
          <Col xs={24} sm={24} md={8}>
            <TrainingSequence
              seqList={seqList}
              setNewSequence={setNewSequence}
              loading={loading}
              type={types.SKILLJOURNEY}
              priorityLoad={priorityLoad}
            />
          </Col>
        )}
      </Row>
    </TrainingListContainer>
  )
}

export default SkillJourneyList
